export default "https://cdn-static.gokick.com/assets/96917af4b324ebd1ae50a0309f8a33967fe87b4d/images/citrus-zen.3d089e3f253b955a4e1c4ecfa30a73d4.png";